import $ from 'jquery';
import '@mockup/func/globals/App.util';
import { App } from './App';

export const newsletterSignup = {
    init: function () {
        $('form[data-signup-ajax="true"]')
            .submit(function () {
                var $form = $(this);
                var error = false;
                var name = $form.find('input[id=name]')[0];
                var email = $form.find('input[id=email]')[0];
                var bekraeftEmail = $form.find('input[id=bekraeftEmail]')[0];
                var newsletters = $form.find('input[type=checkbox]');

                if (newsletters.not(':checked').length === newsletters.length) {
                    newsletters.closest('div.fu').find('div.error').show();
                    newsletters.closest('div.fu').addClass('error');
                    error = true;
                } else {
                    setValidationOk(newsletters);
                    newsletters.closest('div.fu').find('div.error').hide();
                }
                if (!validateEmailRequired(email)) {
                    setValidationError(email);
                    error = true;
                } else {
                    setValidationOk(email);
                }
                if (!validerBekraeftEmail(bekraeftEmail)) {
                    setValidationError(bekraeftEmail);
                    error = true;
                } else {
                    setValidationOk(bekraeftEmail);
                }
                error = !validateName(name) || error;

                if (!error) {
                    $.ajax({
                        url: $form.attr('action'),
                        type: $form.attr('method'),
                        data: $form.serialize()
                    }).done(function (data) {
                        if (data.ok) {
                            $form.trigger('reset');
                            var header = $form.data('success-header');
                            var content = $form.data('success-content');
                            alertify.alert('<h3>' + header + '</h3><center><p>' + content + '</p></center>');
                        } else {
                            var headerFejlDomaene = $form.data('fejldomaene-header');
                            var contentFejlDomaene = $form.data('fejldomaene-content');
                            alertify.alert('<h3>' + headerFejlDomaene + '</h3><center><p>' + contentFejlDomaene + '</p></center>');
                        }
                    });
                }

                return false;
            });
    }
};

export default newsletterSignup;

App.Util.newsletterSignup = newsletterSignup;
